import { Injectable, EventEmitter } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import { StorageService, StorageKeys } from "./storage.service";
import { Base64 } from "js-base64";
import * as htmlToText from "html-to-text";
import { Subject } from "rxjs";
import { LanguageService, Language } from "./language.service";
@Injectable({
  providedIn: "root",
})
export class HelperService {
  private _token: any;
  private _refreshToken: any;
  private _accessToken: any;
  private _idToken: any;
  private _expiry: any;

  public checkoutTestData: any = {};

  constructor(
    private _storageService: StorageService,
    public storage: StorageService,
    private _languageService: LanguageService
  ) {}

  public hasNotifiedExpiredAccessToken: boolean = false;

  public userID: any;

  public mobileTheme: "dark" | "light" = "light";

  get refreshToken() {
    if (!this._refreshToken) {
      let storedRefreshToken = this.storage.getItem(StorageKeys.REFRESHTOKEN);
      if (storedRefreshToken) {
        this._refreshToken = storedRefreshToken;
      } else if (this.cookieTokens) {
        this._refreshToken = this.cookieTokens.refreshToken;
      }
    }
    return this._refreshToken;
  }

  set refreshToken(refreshToken) {
    if (!refreshToken) {
      this.storage.removeItem(StorageKeys.REFRESHTOKEN);
    } else {
      this.storage.setItem(StorageKeys.REFRESHTOKEN, refreshToken);
    }
    this._refreshToken = refreshToken;
  }

  get accessToken() {
    if (!this._accessToken) {
      let storedaccessToken = this.storage.getItem(StorageKeys.ACCESSTOKEN);
      if (storedaccessToken) {
        this._accessToken = storedaccessToken;
      } else if (this.cookieTokens) {
        this._accessToken = this.cookieTokens.accessToken;
      }
    }
    return this._accessToken;
  }

  set accessToken(accessToken) {
    if (!accessToken) {
      this.storage.removeItem(StorageKeys.ACCESSTOKEN);
    } else {
      this.storage.setItem(StorageKeys.ACCESSTOKEN, accessToken);
    }
    this._accessToken = accessToken;
  }

  get idToken() {
    if (!this._idToken) {
      let storedidToken = this.storage.getItem(StorageKeys.IDTOKEN);
      if (storedidToken) {
        this._idToken = storedidToken;
      } else if (this.cookieTokens) {
        this._idToken = this.cookieTokens.idToken;
      }
    }
    return this._idToken;
  }

  set idToken(idToken) {
    if (!idToken) {
      this.storage.removeItem(StorageKeys.IDTOKEN);
    } else {
      this.storage.setItem(StorageKeys.IDTOKEN, idToken);
    }
    this._idToken = idToken;
  }

  get tokenExpiry() {
    if (!this._expiry) {
      let storedExpiry = this.storage.getItem(StorageKeys.TOKENEXPIRY);
      if (storedExpiry) {
        this._expiry = storedExpiry;
      } else if (this.cookieTokens) {
        this._expiry = this.cookieTokens.tokenExpiry;
      }
    }
    return this._expiry;
  }

  set tokenExpiry(expiry) {
    if (!expiry) {
      this.storage.removeItem(StorageKeys.TOKENEXPIRY);
    } else {
      this.storage.setItem(StorageKeys.TOKENEXPIRY, expiry);
    }
    this._expiry = expiry;
  }

  get token() {
    if (!this._token) {
      let storedToken = this.storage.getItem(StorageKeys.ACCESSTOKEN);
      if (storedToken) {
        this._token = storedToken;
      } else if (this.accessToken) {
        this._token = this.accessToken;
      }
    }
    return this._token;
  }

  set token(token) {
    if (!token) {
      this.storage.removeItem(StorageKeys.TOKEN);
    } else {
      this.storage.setItem(StorageKeys.TOKEN, token);
    }
    this._token = token;
  }

  private _cookieTokens: {
    accessToken: string;
    idToken: string;
    refreshToken: string;
    tokenExpiry: number;
  };
  get cookieTokens() {
    return this._cookieTokens;
  }

  set cookieTokens(tokens) {
    this._cookieTokens = tokens;
  }

  private _cookieToken: any;
  get cookieToken() {
    return this._cookieToken;
  }

  set cookieToken(token) {
    this._cookieToken = token;
  }

  public getHttpOptions(includeToken = true, userID?, customToken?) {
    let args = {
      "Content-Type": "application/json",
      "X-API-KEY": environment.presonusApiKey,
    };
    if (includeToken) {
      if (customToken) {
        args["X-USER-TOKEN"] = customToken;
      } else {
        if (!this.token) {
          this.token = this._storageService.getItem(StorageKeys.TOKEN);
        }
        if (!this.token) {
          if (this.cookieToken) {
            this.token = this.cookieToken;
          }
        }
        if (this.token) {
          // console.log("%cAPI CALL WITH: " + this.token.substr(this.token.length - 5));
          args["X-USER-TOKEN"] = this.token;
        }
      }
    }
    if (userID) {
      let userEncrypedID = Base64.encode(userID);
      args["X-USER-ENCRYPTED-ID"] = userEncrypedID;
    }
    if (this.userID) args["X-NEO-MORPHEUS"] = Base64.encode(this.userID);
    return { headers: new HttpHeaders(args) };
  }

  public getPaeApiOptions(accessToken?) {
    let args = {
      "Content-Type": "application/json",
    };
    if (accessToken) args["X-USER-TOKEN"] = accessToken;
    return { headers: new HttpHeaders(args) };
  }

  public validateEmail(email) {
    return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/.test(email);
  }

  public shuffleArray<T>(array: T[]): T[] {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  public stripHtml(string, replaceLineBreaks?, trimWhiteSpace?) {
    let result = "";
    if (string) {
      result = string;
      if (replaceLineBreaks) {
        // Replace <br> and <br/> tags with a newline character
        result = result.replace(/<br\s*\/?>/gi, "\n");
        // Replace <p> and </p> tags with a newline character
        result = result.replace(/<\/?p>/gi, "\n");
      }

      // Remove the rest of the HTML tags
      result = result.replace(/<\/?[^>]+(>|$)/g, "");
      result = result.replace(/&nbsp;/gi, " ");
      if (trimWhiteSpace) result = result.trim();
    }
    return result;
  }

  public containsHtml(text: string): boolean {
    return /<[^>]*>/.test(text || "");
  }

  htmlToMarkdown(html) {
    // Replace line breaks
    let markdown = html.replace(/<br\s*\/?>/gi, "\n");

    // Remove spans with class="ql-ui"
    markdown = markdown.replace(/<span[^>]*class="[^"]*\bql-ui\b[^"]*"[^>]*>.*?<\/span>/gis, "");

    // Remove <u> tags (underline is not standard in Markdown)
    markdown = markdown.replace(/<u>(.*?)<\/u>/gi, "$1");

    // Replace <strong> and <b> tags with Markdown bold
    markdown = markdown.replace(/<strong>(.*?)<\/strong>/gi, "**$1**");
    markdown = markdown.replace(/<b>(.*?)<\/b>/gi, "**$1**");

    // Replace <em> and <i> tags with Markdown italics
    markdown = markdown.replace(/<em>(.*?)<\/em>/gi, "*$1*");
    markdown = markdown.replace(/<i>(.*?)<\/i>/gi, "*$1*");

    // Replace <s> and <strike> tags with Markdown strikethrough
    markdown = markdown.replace(/<s>(.*?)<\/s>/gi, "~~$1~~");
    markdown = markdown.replace(/<strike>(.*?)<\/strike>/gi, "~~$1~~");

    // Replace <h1> to <h6> with corresponding Markdown headers
    for (let i = 6; i >= 1; i--) {
      const hTag = new RegExp(`<h${i}[^>]*>(.*?)<\/h${i}>`, "gi");
      markdown = markdown.replace(hTag, `${"#".repeat(i)} $1\n`);
    }

    // Replace <a> tags with Markdown links
    markdown = markdown.replace(/<a href="(.*?)">(.*?)<\/a>/gi, "[$2]($1)");

    // Handle code blocks
    markdown = markdown.replace(/<div[^>]*class="[^"]*\bql-code-block\b[^"]*"[^>]*>(.*?)<\/div>/gis, function (match, codeContent) {
      return "\n```\n" + codeContent.trim() + "\n```\n";
    });

    // Remove any remaining <div> tags (including ql-code-block-container)
    markdown = markdown.replace(/<\/?div[^>]*>/gi, "");

    // Replace <li> elements with data-list attributes
    markdown = markdown.replace(/<li[^>]*data-list="(.*?)"[^>]*>(.*?)<\/li>/gis, function (match, listType, content) {
      content = content.trim();
      // Remove any remaining HTML tags in content
      content = content.replace(/<\/?[^>]+(>|$)/g, "");
      if (listType === "ordered") {
        return "1. " + content + "\n";
      } else if (listType === "bullet") {
        return "- " + content + "\n";
      } else {
        return "* " + content + "\n";
      }
    });

    // Remove any remaining <ol> and <ul> tags
    markdown = markdown.replace(/<\/?(ol|ul)[^>]*>/gi, "");

    // Replace <blockquote> with Markdown blockquotes
    markdown = markdown.replace(/<blockquote[^>]*>(.*?)<\/blockquote>/gis, function (match, content) {
      return "> " + content.trim() + "\n";
    });

    // Replace <p> tags with newlines
    markdown = markdown.replace(/<\/?p[^>]*>/gi, "\n");

    // Remove any remaining HTML tags
    markdown = markdown.replace(/<\/?[^>]+(>|$)/g, "");

    // Collapse multiple consecutive newlines into a single newline
    markdown = markdown.replace(/\n{2,}/g, "\n\n");

    markdown = markdown.replace(/&nbsp;/g, " ");

    // Trim extra whitespace
    return markdown.trim();
  }

  sanitizeQuillListHtml(html: string): string {
    if (!html) return html;
    html = html.replace(/^(<p><br><\/p>)+/, "");
    html = html.replace(/(<p><br><\/p>)+$/, "");
    html = html.replace(/<ol>([\s\S]*?)<\/ol>/g, (_match, inner) => {
      if (inner.includes('data-list="bullet"')) {
        const cleaned = inner.replace(/ data-list="bullet"/g, "").replace(/<span class="ql-ui" contenteditable="false"><\/span>/g, "");
        return `<ul>${cleaned}</ul>`;
      }
      return `<ol>${inner.replace(/ data-list="ordered"/g, "").replace(/<span class="ql-ui" contenteditable="false"><\/span>/g, "")}</ol>`;
    });
    return html;
  }

  sanitizeQuillHtml(html: string): string {
    if (!html) return html;
    html = html.replace(/<p class="ql-blank-line"><br><\/p>/g, '<p class="ql-blank-line"></p>');
    html = html.replace(/<p><br><\/p>/g, '<p class="ql-blank-line"></p>');
    html = html.replace(/<p class="ql-blank-line">(?!<\/p>)/g, "<p>");
    html = this.sanitizeQuillListHtml(html);
    html = html.replace(/(<p class="ql-blank-line"><\/p>)+$/, "");
    return html;
  }

  makeHtml(text) {
    text = this.urlify(text);
    text = text.replace(/(?:\n\n\n)/g, "<br /><br />");
    text = text.replace(/(?:\r\r\r)/g, "<br /><br />");
    text = text.replace(/(?:\n\n)/g, "<br /><br />");
    text = text.replace(/(?:\n)/g, "<br />");
    text = text.replace(/(?:\r\r)/g, "<br />");
    text = text.replace(/(?:\r\n|\r|\n)/g, "<br />");
    return text;
  }

  convertLineBreaks(text: string): string {
    if (!text || this.containsHtml(text)) return text;
    return text.replace(/(?:\r\n|\r|\n)/g, "<br />");
  }

  urlify(text) {
    if (text) {
      var urlRegex = /(\bhttps?:\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
    } else {
      return text;
    }
  }

  public hhmmss(secs, pretty = false) {
    if (secs) {
      if (typeof secs === "string") secs = parseInt(secs);
      secs = secs.toFixed(0);
      var minutes: any = Math.floor(secs / 60);
      secs = secs % 60;
      var hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      if (pretty) {
        if (hours) {
          return hours + "h " + minutes + "m";
        } else {
          return minutes ? minutes + "m" : "<1m";
        }
      } else {
        if (hours) {
          if (minutes < 10) minutes = "0" + minutes;
          return `${hours}:${minutes}:${("0" + secs).slice(-2)}`;
        } else {
          return `${minutes}:${("0" + secs).slice(-2)}`;
        }
      }
    } else {
      return "0s";
    }
  }

  // `acceptableMentionKeys` lived here: an a-z + space allowlist the old mention
  // code appended keystrokes through, which silently dropped digits, hyphens,
  // apostrophes and every accented character -- so those names could not be
  // mentioned at all. The engine in utils/mention.utils.ts derives the query from
  // the text instead, so no keyboard allowlist is needed.

  public htmlToText(html, useConverter = true, ignoreImages = true) {
    // const { convert } = require("html-to-text");
    // There is also an alias to `convert` called `htmlToText`.
    // https://github.com/html-to-text/node-html-to-text/tree/master/packages/html-to-text
    if (useConverter) {
      const options = {
        // No hard wrapping. html-to-text's wordwrap inserts a real "\n" at the last space
        // before each N columns — fine for a plain-text email, wrong for everything this
        // feeds: chat bubbles, push bodies, snippets. At 130 it put line breaks mid-sentence
        // into every long message on mobile (the web renders the HTML instead, so it never
        // showed there). Wrapping is the view's job.
        wordwrap: false,
        selectors: [],
      };
      if (ignoreImages) options.selectors.push({ selector: "img", format: "skip" });

      return htmlToText.convert(html, options);
    } else {
      html = html.replace(/<[^>]+>/g, "");
      html = html.replace(/&nbsp;/g, "");
      return html;
    }
  }

  retrieveErrorMessage(error) {
    if (error && error.error && (error.error.error || error.error.message_plain || error.error.message || error.error.message)) {
      return error.error.error || error.error.message_plain || error.error.message || error.error.reason;
    } else if (error && error.message) {
      return error.message;
    } else if (error.error) {
      return error.error;
    } else {
      return "An unknown error occurred.";
    }
  }

  public exchangeDeployed: boolean = false;

  /**
   * @deprecated Use LanguageService.languages instead
   * Kept for backward compatibility
   */
  get languages(): Language[] {
    return this._languageService.languages;
  }

  /**
   * @deprecated Use LanguageService.selectedLanguage instead
   * Kept for backward compatibility
   */
  get selectedLanguage(): Language {
    return this._languageService.selectedLanguage;
  }

  /**
   * @deprecated Use LanguageService.selectedLanguage setter instead
   * Kept for backward compatibility
   */
  set selectedLanguage(lang: string | Language) {
    this._languageService.selectedLanguage = lang;
  }

  public backPressed$: Subject<boolean> = new Subject();
  public navigatingBack: boolean;
  public goBack() {
    this.navigatingBack = true;
    this.backPressed$.next(true);
    setTimeout(() => {
      this.navigatingBack = false;
    }, 300);
  }

  /**
   * Rewrites a raw fmicassets.com PIM image URL through Cloudflare Image Resizing,
   * inferring rotation from the `_rr`/`_rl` filename-suffix convention FMIC uses.
   */
  cdnProductImage(url: string): string {
    if (!url) return url;
    const rotate = url.indexOf("_rr") > -1 ? "rotate=270," : url.indexOf("_rl") > -1 ? "rotate=90," : "";
    return `https://www.fender.com/cdn-cgi/image/format=auto,${rotate}resize=height=auto,width=1000/${url}`;
  }

  /**
   * Groups a PIM `images` bundle (e.g. `{mainZoomAll: [url, url], mainLgAll: [...]}`) into
   * displayable `{label, urls}` rows, CDN-rewriting each URL. Shared by the admin Fender
   * product detail page and the customer-facing product detail page.
   */
  buildImageRows(images: { [setName: string]: string | string[] }): Array<{ label: string; urls: string[] }> {
    const zoom = images?.["mainZoomAll"];
    const urls: string[] = Array.isArray(zoom) ? zoom.filter((u) => typeof u === "string") : [];
    if (!urls.length) return [];
    return [{ label: "admin_portal.main_zoom_all", urls: urls.map((u) => this.cdnProductImage(u)) }];
  }

  /**
   * Picks the current-OS installer for a software product's OWN download (dashboard tile,
   * product tile, "download hub" quick-download buttons) from `softwareDownloads` — replaces
   * five copies of the same `snapshot.downloads.installers.{mac,win64,win}[0]` lookup, which
   * only ever worked for a product's own installer and had no way to notice a PIM-only
   * software product had moved past its legacy `downloads.installers` bucket (see the same
   * class of staleness bug fixed for the installer-buttons sidebar). A software product's
   * snapshot has exactly one softwareDownloads group (see the categoryId shortcut in
   * paeapi's buildSoftwareDownloads), named from the product's own title — falls back to the
   * sole group when present in case the title doesn't match exactly (translation/casing drift).
   */
  getInstallerForCurrentOs(softwareDownloads: Array<{ type: string; latest?: { platforms?: any[] } }> | undefined, productTitle: string, myOs: string): any {
    const groups = softwareDownloads || [];
    const ownGroup = groups.find((g) => g.type === productTitle) || (groups.length === 1 ? groups[0] : null);
    const platforms = ownGroup?.latest?.platforms || [];
    if (myOs === "win") {
      // Mirrors the old lookup's own priority: prefer a distinct win64 bucket when a product
      // has one, otherwise the plain win bucket (already 64-bit for most products today).
      return platforms.find((p: any) => (p.platform || "").toLowerCase() === "win64") || platforms.find((p: any) => (p.platform || "").toLowerCase() === "win") || null;
    }
    return platforms.find((p: any) => (p.platform || "").toLowerCase() === myOs) || null;
  }
}
